// extracted by mini-css-extract-plugin
export default {"overlay":"Wv-z","bodyOpen":"Xv-z","content":"Yv-z","header":"Zv-z","close":"_v-z","closeNoHeading":"aw-z"};